export default "__VITE_ASSET__gq9Td6B0__"